export enum IntegrationStep {
  NONE = 'none',
  CONNECT = 'connect',
  CONFIRM = 'confirm',
  CONFIRMED = 'confirmed',
  DISCONNECT = 'disconnect',
  DISCONNECTED = 'disconnected',
}
